export enum PersistedStorageKeys {
    TagSelected = "agentsTableTags",
    TagGroupSelected = "agentsTableTagGroups",
    LiveSummaryTagGroupSelected = "liveSummaryTagGroup",
}
